import { render, staticRenderFns } from "./direccion-suministro.vue?vue&type=template&id=23afbbfe&"
import script from "./direccion-suministro.vue?vue&type=script&lang=js&"
export * from "./direccion-suministro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports